import { Navigate, Outlet, useLocation } from "react-router"
import { useIsBirddogForester } from "../hooks/useBirddogProfile"
import BirddogLayout from "./BirddogLayout"

export const ForesterProtectedRoute = () => {
  const location = useLocation()
  const isForester = useIsBirddogForester()

  if (!isForester) {
    return (
      <BirddogLayout>
        <div className="min-h-screen flex items-center justify-center">
          <div className="text-center">
            <h1 className="text-2xl font-bold text-gray-900">Access Denied</h1>
            <p className="text-gray-600 mt-2">
              This page is only available to foresters. You must be a forester
              to create and edit timber sales.
            </p>
            <div className="mt-4">
              <Navigate
                replace
                to="/birddog/dashboard"
                state={{ from: location }}
              />
            </div>
          </div>
        </div>
      </BirddogLayout>
    )
  }

  return <Outlet />
}
